<template>
    <span class="font-robotomono">{{ timeRunning }}</span>
</template>

<script setup>
import {computed, onBeforeUnmount, onMounted, ref, watch} from "vue";

const props = defineProps({
    seconds: {
        type: Number,
        default: 0
    },
    play: { type: Boolean, default: false}
})

const secondsNow = ref(props.seconds)

watch(() => props.play, (val) => {
    if(val){
        increment()
    }else if(!val){
        clearTimeout(secondsCountUp.value)
    }
})

const secondsCountUp = ref(null)

const timeRunning = computed(() => {

    const totalMinutes = Math.floor(secondsNow.value / 60);

    let seconds = Math.abs(secondsNow.value % 60);
    let hours = Math.abs(Math.floor(totalMinutes / 60) % 24);
    let minutes = Math.abs(totalMinutes % 60);
    let days = Math.floor(secondsNow.value / (60*60*24)) > 0 ? Math.floor(secondsNow.value / (60*60*24)) : 0;

    hours = String(hours).length < 2 ? ("0" + hours) : hours
    minutes = String(minutes).length < 2 ? ("0" + minutes) : minutes
    seconds = String(seconds).length < 2 ? ("0" + seconds) : seconds

    if(days > 0){
        days =  String(days).length < 2 ? ("0" + days) : days
        return `${days} dia(s) ${hours}:${minutes}:${seconds}`
    }
    return `${hours}:${minutes}:${seconds}`
})

function increment() {
    secondsNow.value = secondsNow.value + 1
    secondsCountUp.value = setTimeout(() => {
        increment()
    }, 1000)
}

onBeforeUnmount(() => {
    clearTimeout(secondsCountUp.value)
})

onMounted(() => {
    if(props.play){
        increment()
    }
})
</script>

